const EMPTY_FEED = Object.freeze({
  rows: [],
  offset: 0,
  pageSize: 50,
  total: 0,
  isLoading: false,
  error: null,
});

const targetKey = (type, id) => `${type}:${id}`;

export const selectOwnerFeed = (state, ownerType, ownerId) =>
  state.activityLog.owner[targetKey(ownerType, ownerId)] ?? EMPTY_FEED;

export const selectEntityFeed = (state, entityType, entityId) =>
  state.activityLog.entity[targetKey(entityType, entityId)] ?? EMPTY_FEED;
